<template>
  <div v-if="localComment && (statuses.length > 0) && (members.length > 0) && status && commenter">
    <v-card :class="localComment.attributes.shared && 'shared' || ''">
      <v-card-title>
        <v-layout row>
          <v-avatar v-if="commenterThumbUrl" size=48>
            <img :src="commenterThumbUrl" alt="Avatar" class="commenterLogo">
          </v-avatar>
          <v-icon v-else size=48>person_outline</v-icon>

          <v-flex class="subheading text-truncate ml-3 pt-2">
            <span v-if="!commenter.attributes.discarded_at">{{commenter.attributes.name || commenter.atttributes.email}}</span>
            <span v-else class="font-weight-thin font-italic grey--text lighten-3">{{commenter.attributes.name || commenter.atttributes.email}}</span>
            <br>
            <span slot="activator" class="caption">
              {{ localComment.attributes.updated_at | formatDateAgo }} on {{ localComment.attributes.updated_at | formatDateLong}}
            </span>
          </v-flex>
        </v-layout>
        <v-icon class="ml-3" v-if="permit.canDeleteComment(localComment)" @click="deleteComment = !deleteComment">delete</v-icon>
        <v-icon class="ml-3" v-if="permit.canEditComment(localComment)" @click="editComment = !editComment">edit</v-icon>
        <v-icon class="ml-3" v-if="permit.canShareTicket(ticket)" @click="shareComment()" :color="localComment.attributes.shared && 'success' || '#ccc'">campaign</v-icon>
      </v-card-title>

      <v-card-text class="pt-0">
        <v-layout row wrap>
          <v-flex xs12>
            <div class="pl-2 comment trix-content" @click="commentMessageClick" v-html="localComment.attributes.message" v-if="localComment.attributes.is_html"></div>
            <div class="pl-2 comment trix-content" v-else>{{localComment.attributes.message}}</div>
          </v-flex>

          <v-flex xs12 sm3 lg2 v-for="(att, idx) in (localComment.attributes.attachments)" :key="idx" class="attachment ma-1 pa-1 text-xs-center text-truncate text-nowrap caption">
            <a :href="auth.decorate_path_with_access_params(att.download_url)" target="attachments">
              <v-img
                v-if="att.content_type.includes('image')"
                class="hidden-xs-only mb-2"
                height=100
                contain
                :src="auth.decorate_path_with_access_params(att.preview_url)"
              />
              <v-icon size=120 class="hidden-xs-only" v-else>attachment</v-icon>
              <br>
              <span class="pt-2">
                {{att.filename}}
                <br>
                {{att.filesize | toFileSize}}
              </span>
            </a>
            <v-icon small class="right" v-if="permit.canDeleteAttachment(localComment)" @click="localAttachment = Object.assign({}, att); deleteAttachment = !deleteAttachment">delete</v-icon>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="pt-3">
          <v-flex xs3 sm3 lg1 class="caption text-uppercase text-xs-right pr-2 pt-1">Status</v-flex>
          <v-flex xs3 sm3 lg2>
            <v-chip :color="status.attributes.color" disabled small outline class="ma-0 pa-0">
              {{status.attributes.name }}
            </v-chip>
          </v-flex>

          <v-flex xs3 sm3 lg1 class="caption text-uppercase text-xs-right pr-2 pt-1">Assigned</v-flex>
          <v-flex xs3 sm3 lg2 v-if="assignee && assignee.attributes">
            <v-chip outline disabled small class="ma-0 pa-0">
              <v-avatar v-if="assigneeThumbUrl" size=24>
                <img :src="assigneeThumbUrl" alt="Avatar">
              </v-avatar>
              {{assignee.attributes.name}}
            </v-chip>
          </v-flex>
          <v-flex xs3 sm3 lg2 v-else></v-flex>

          <v-flex xs3 sm3 lg1 class="caption text-uppercase text-xs-right pr-2">
            <v-btn small @click="splitTicket()" class="ma-0 grey--text pr-0">
              split
              <v-icon size=24>call_split</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs3 sm3 lg2 v-if="splitTickets.length > 0">
            <span v-for="(tck, idx) in splitTickets" :key="idx">
              <a :href="tck.links.project_show_uri" target="split_ticket">
                <v-chip outline small>{{tck.attributes.sequential_id}} - {{tck.attributes.title.substr(0,9)}}</v-chip>
              </a>
            </span>
          </v-flex>
          <v-flex xs3 sm3 lg2 v-else></v-flex>

          <v-flex xs3 sm3 lg1 class="caption text-uppercase text-xs-right pr-2 pt-1">Priority</v-flex>
          <v-flex xs3 sm3 lg2>
            <v-avatar size=24>
              <v-icon v-show="lowPriority" color="#ff6600">star_outline</v-icon>
              <v-icon v-show="mediumPriority" color="#ff6600">star_half</v-icon>
              <v-icon v-show="highPriority" color="#ff6600">star</v-icon>
            </v-avatar>
          </v-flex>
        </v-layout>

        <v-layout v-if="localComment.attributes.tag_list.length > 0" class="mt-3">
          <v-flex xs3 sm3 lg1 class="caption text-uppercase text-xs-right pr-2 pt-1">Tags</v-flex>
          <v-flex xs10 sm10 lg11>
            <span v-for="(tag, idx) in localComment.attributes.tag_list" :key="idx">
              <v-chip disabled outline small class="ma-0 pa-0">{{tag}}</v-chip>
            </span>
          </v-flex>
        </v-layout>
      </v-card-text>

    </v-card>

    <v-dialog
      :fullscreen="$vuetify.breakpoint.xsOnly"
      v-model="editComment"
      max-width="65%"
      persistent
      >
      <commentEdit :comment="localComment" :ticket="ticket" :project="project" :statuses="statuses" :boards="boards" :members="members.filter(m => !m.attributes.discarded_at)"></commentEdit>
    </v-dialog>

    <v-dialog
      :fullscreen="$vuetify.breakpoint.xsOnly"
      v-model="deleteComment"
      max-width="500px"
      persistent
      >
      <commentDelete :comment="localComment"></commentDelete>
    </v-dialog>

    <v-dialog
      :fullscreen="$vuetify.breakpoint.xsOnly"
      v-model="deleteAttachment"
      max-width="500px"
      persistent
      >
      <commentAttachmentDelete :comment="localComment" :attachment="localAttachment"></commentAttachmentDelete>
    </v-dialog>
  </div>
</template>

<script>
  import { EventBus } from '@/utilities/event-bus'
  import permissions from '@/utilities/permissions'
  import authentication from '@/utilities/authentication'

  import ticketService from '@/services/ticket'
  import commentService from '@/services/comment'

  import commentEdit from '@/components/comment/_edit'
  import commentDelete from '@/components/comment/_delete'
  import commentAttachmentDelete from '@/components/comment/_attachment_delete'

  export default {
    name: 'ticket-comment',

    // boards is not used here, just passed through to the edit dialog
    props: ['comment', 'ticket', 'project', 'statuses', 'boards', 'members'],

    components: {
      commentEdit: commentEdit,
      commentDelete: commentDelete,
      commentAttachmentDelete: commentAttachmentDelete
    },

    data () {
      return {
        auth: authentication,
        permit: permissions,
        localComment: null,
        localAttachment: null,
        status: null,
        assignee: null,
        commenter: null,
        splitTickets: [],

        // dialogs
        editComment: false,
        deleteComment: false,
        deleteAttachment: false
      }
    },

    computed: {
      commenterThumbUrl () {
        if (this.commenter && this.commenter.links && this.commenter.links.avatar_uri) {
          return (process.env.API_URL + this.commenter.links.avatar_uri)
        }
      },

      assigneeThumbUrl () {
        if (this.assignee && this.assignee.links && this.assignee.links.avatar_uri) {
          return (process.env.API_URL + this.assignee.links.avatar_uri)
        }
      },

      lowPriority () {
        return (this.localComment.attributes.priority == 'low') || (this.localComment.attributes.priority == null)
      },

      mediumPriority () {
        return (this.localComment.attributes.priority == 'medium')
      },

      highPriority () {
        return (this.localComment.attributes.priority == 'high')
      }
    },

    mounted () {
      this.localComment = Object.assign({}, this.comment)
      this.assignee = this.membershipFromUser(this.comment.relationships.assignee)
      this.commenter = this.membershipFromUser(this.comment.relationships.commenter)

      this.findStatus()
      this.loadSplitTickets()

      EventBus.$on('comment-updated', (payload) => {
        // close the dialog
        this.editComment = false
        // update our local copy if it's us
        if (payload && (parseInt(this.comment.id) === parseInt(payload.id))) {
          this.localComment = Object.assign({}, payload)
          this.assignee = this.membershipFromUser(this.localComment.relationships.assignee)
          this.findStatus()
        }
      })

      EventBus.$on('comment-deleted', (payload) => {
        // close the dialog
        this.deleteComment = false
        // The ticket component will remove the comment from the page
      })

      EventBus.$on('comment-attachment-deleted', (payload) => {
        // close the dialog
        this.deleteAttachment = false
        if (payload) {
          // remove the attachment from the page
          this.localComment.attributes.attachments = this.localComment.attributes.attachments.filter(att => parseInt(payload.id) !== parseInt(att.id))
        }
      })
    },

    methods: {
      commentMessageClick (e) {
        if (e.target.matches('img')) {
          if (e.target.classList.contains('expanded')) {
            e.target.classList.remove('expanded')
          } else {
            e.target.classList.add('expanded')
          }
        }
      },

      findStatus () {
        this.status = Object.assign({}, this.statuses.find((st) => parseInt(st.id) === parseInt(this.localComment.relationships.status.data.id)))
      },

      membershipFromUser (user) {
        let member = null
        if (user && user.data && user.data.id) {
          member = this.members.find((mem) => parseInt(mem.relationships.user.data.id) === parseInt(user.data.id))
        }
        return member
      },

      loadSplitTickets () {
        this.localComment.relationships.split_tickets.data.forEach((split) => {
          ticketService.show(
            (data) => {
              this.splitTickets.push(data)
            },
            (err) => {
              console.log(err)
            },
            split.id
          )
        })

        // I'm leaving this here for reference:
        // in general there are probably fewer split tickets peppered through the comments on a ticket, than
        // there are comments on the ticket. So it's more efficient deliberately loading the splits we do find,
        // rather that loading (probably) no splits on (likely) most comments
        // ticketService.commentIndex(
        //   (data) => {
        //     this.splitTickets = data
        //   },
        //   (err) => {
        //     console.log(err)
        //   },
        //   this.localComment.id
        // )
      },

      splitTicket () {
        EventBus.$emit('split-ticket', this.localComment)

        // also then listen for the reply so we can update ourselves
        EventBus.$on('ticket-created', (payload) => {
          if (payload) {
            // check if this belongs to us
            if (parseInt(payload.relationships.parent.data.id) === parseInt(this.localComment.id)) {
              this.splitTickets.push(payload)
            }
          }
        })
      },

      shareComment () {
        this.localComment.attributes.shared = !this.localComment.attributes.shared
        commentService.share(
          (data) => {
            // nothing to do here
          },
          (err) => {
            console.log(err)
          },
          this.localComment.attributes
        )
      }
    }
  }
</script>

<style lang="scss" scoped>
  .attachment {
    border: 1px solid #d3d3d3;
  }

  .comment {
    white-space: pre-wrap;
  }

  .shared {
    // background-image: linear-gradient(135deg, rgb(255, 255, 255) 95%, rgb(76, 175, 80));
    border: 2px solid rgb(25, 118, 210);
  }

</style>



// WEBPACK FOOTER //
// src/components/ticket/_comment.vue